import script from "./Dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=55a4b3db&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a4b3db"]])

export default __exports__